<div class="page-center">
  <p-card class="otp-card text-center" header="Enable Authenticator">
    <p>Scan this QR code using Authenticator app</p>
    <div class="otp-container">
      <div><img [src]="qrCode" *ngIf="qrCode" alt="QRCODE" /></div>
      <div><button class="btn submit" (click)="proceed()">Next</button></div>
    </div>
  </p-card>
</div>
